module.exports = (url, clb) => {
    var head = document.getElementsByTagName("head")[0];
    if (document.querySelector('link[href="' + url + '"]')) {
        clb && clb(null, true);
        return
    }
    var link = document.createElement("link");
    link.href = url;
    link.rel = 'stylesheet';
    link.onerror = function() { 
        clb && clb.bind(link, true).call()
        head.removeChild(link);
    }
    link.onload  = clb && clb.bind(link, false)


    // document.getElementsByTagName("head")[0].appendChild(link);


    head.insertBefore(link, head.firstChild);

};



/** WEBPACK FOOTER **
 ** ../src/common/loadStyle.js
 **/